export default __webpack_public_path__ + "images/5f77b5560a6767af3682599a1d244b82.svg";